//  活动菜单子页面-菜单路由映射表
const hdChildForm = {
  1: "/integralCenter/integralTask/signIn",
  2: "/integralCenter/integralTask/Grabgifts",
  3: "/integralCenter/integralTask/followShop",
  4: "/integralCenter/integralTask/inviteCard",
  5: "/integralCenter/integralTask/inviteShop",
  6: "/integralCenter/integralTask/perfectNews",
  8: "/integralCenter/interesting/turntable",
  16: "/integralCenter/integralEden/overbooking",
  17: "/integralCenter/integralEden/firstPurchase",
  18: "/integralCenter/integralEden/fgPurchase",
  19: "/integralCenter/integralEden/lottergdraw",
  21: "/integralCenter/integralTask/fission",
  22: "/integralCenter/integralTask/redPacket",
  23: "/integralCenter/gameHub/prizeClaw",
  24: "/integralCenter/gameHub/differences",
  25: "/integralCenter/integralTask/joinAndRank",
  26: "/integralCenter/integralTask/luckyLottery",
  27: "/integralCenter/integralTask/freeTryOut",
  31: "/integralCenter/integralEden/questionnaire",
  32: "/integralCenter/integralEden/birthdayGift",
  33: "/integralCenter/integralEden/pointExchange",
  34: "/integralCenter/integralEden/fulfilQuota",
  35: "/integralCenter/integralEden/orderRank",
  37: "/integralCenter/integralEden/memberUpgradeGift",
}

// 小部件菜单子页面-菜单路由映射表
const cardChildForm = {
  "/integralCenter/activeCard": "/integralCenter/cardManagement/liveCard",
  "/integralCenter/cardManagement/smartPosterEdit": "/integralCenter/cardManagement/smartPost",
  "/integralCenter/cardManagement/scratchersEdit": "/integralCenter/cardManagement/scratch",
  "/integralCenter/cardManagement/freeTrialEdit": "/integralCenter/cardManagement/freeTrial",
}

// 路由白名单
const whiteList = [
  "",
  "/",
  "/nopermission",
  "/login",
  "/home",
  "/redirection",
  "/api/taohd/auth",
  "/integralCenter/home"
]

export const checkPermisson = (path, query) => {
  if(whiteList.includes(path)) {
    return true
  } else {
    const permission = JSON.parse(localStorage.getItem("permissionPath_thd")) || []
    if(permission.includes(path)) {
      return true
    } else {
      // 判断小部件子页面权限
      if(cardChildForm[path]) {
        if(permission.includes(cardChildForm[path])) {
          return true
        } else {
          return false
        }
      }
      
      // 判断活动子页面权限
      if(query.activityData && hdChildForm[query.activityData.id]) {
        if(permission.includes(hdChildForm[query.activityData.id])) {
          return true
        } else {
          return false
        }
      }
      
      return false
    }
  }
}